import Header from "./../../../Headers/HeaderForAreLoggedIn/index.vue"
import Footer from "./../../../Footers/Footer/index.vue"
import ProgressHUD from "./../../../ProgressHUD/index.vue"
import QuestionsAnswers from "./../../Widget/QuestionsAnswers/index.vue"
import ReputationData from "./../../Widget/ReputationData/index.vue"
import Api from "./../../../../services/api"
import { ProductUpdateMixin } from './../../../mixins/ProductUpdate.mixin.js'
import { VueEditor } from "vue2-editor"
let vm = require('vue');

export default {
  name: "ServicesDuplicate",
  mixins:[ProductUpdateMixin],
  components: {
    Header,
    Footer,
    ProgressHUD,
    QuestionsAnswers,
    ReputationData,
    VueEditor
  },
  data() {
    return {
      product: {
        name: '',
        description: '',
        rangePrices: '',
        type: 'Service',
        phone: '',
        email: '',
        country: '',
        region: '',
        images: [''],
        details: '',
        payMethods: []
      }
    }
  },
  async created() {
    this.countries = require('./../../../../data/country.js')
    var response = await Api.getProductById(this.$route.params.id)

    if (response.data && !response.data.error) {
      this.product.name = response.data.results.product.name
      this.product.description = response.data.results.product.description
      this.product.rangePrices = response.data.results.product.rangePrices
      this.product.type = response.data.results.product.type
      this.product.phone = response.data.results.product.phone
      this.product.email = response.data.results.product.email
      this.product.country = response.data.results.product.country
      this.product.region = response.data.results.product.region
      this.product.details = response.data.results.product.details
      this.product.payMethods = response.data.results.product.payMethods
      //this.product.images = response.data.results.product.images
      //this.newImages = [].concat(this.product.images);
    } else {
      this.validationMessage = "Something went wrong."
      console.error("Something went wrong.")
    }

    this.$refs.progress.hide()
  },
  mounted() {
    $(".modal").modal()
    $("select").material_select()
    var _s = this
    this.$refs.selectCountry.onchange = function(){
      _s.product.country = this.value;
    }
  },
  methods: {
    async saveProduct() {
      try{
        let isValid = await this.$validator.validateAll("firstForm")
        if (!isValid) return

        if (!this.editorIsNotEmpty(this.product.description)) return

        if (!this.editorIsNotEmpty(this.product.specs)) return

        var formData = new FormData()
        formData.append("type", this.product.type)
        formData.append("name", this.product.name)
        formData.append("description", this.product.description)
        formData.append("rangePrices", this.product.rangePrices)
        formData.append("email", this.product.email)
        formData.append('country', this.product.country)
        formData.append("phone", this.product.phone)
        formData.append("region", this.product.region)
        formData.append("images", this.product.images)
        formData.append("details", String(JSON.stringify(this.product.details)))
        formData.append("payMethods", this.product.payMethods)

        // Append images to formData
        for (
          var index = 0;
          !(!(index < this.product.images.length) || !(index < 5)); // Upload 5 images or less
          index++
        ) {
          formData.append("files" + index, this.product.images[index])
        }

        var response = await Api.createService(formData)

        this.$router.push('/dashboard/')
      } catch (error) {
        console.error(error)
        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: error.message,
        })
      } finally {
        this.$refs.progress.hide()
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/Marketplace/Services/Duplicate/ServicesDuplicate.component.js